import React, { useState, useEffect } from 'react'
import axios from 'axios'
import styled from 'styled-components'
import PageTitle from '../../../_Components/Common/PageTitle/PageTitle'
import Preview from './Preview'
import EditTable from './EditTable'
import Dropdown from '../../NewApp/Dropdown'
import { DMM_API_KEY, DMM_API_HOST } from '../../../_Components/Common/common'

const Onboarding = () => {
  const [category, setCategory] = useState('Recommended')
  const [categoryList, setCategoryList] = useState([])
  const [assistantList, setAssistantList] = useState([])
  const [create, setCreate] = useState(false)
  const [gender, setGender] = useState('all')

  const genderList = ['all', 'male', 'female']

  useEffect(() => {
    getCategoryList()
  }, [])

  useEffect(() => {
    getOnboarding(category, gender)
  }, [category, gender])

  const getCategoryList = async () => {
    await axios
      .get(`/new/webAdmin/v2/assistant/category?menu=onboarding`, {
        headers: {
          token: sessionStorage.getItem('token'),
        },
      })
      .then(({ data }) => {
        console.log(data.result)
        setCategoryList(data.result)
      })
  }

  const getOnboarding = async (category, gender) => {
    await axios
      .get(
        `${DMM_API_HOST}/v4.0.1/assistant/onboarding?category=${category}&gender=${
          gender ? gender : 'all'
        }`,
        {
          headers: {
            apikey: DMM_API_KEY,
          },
        }
      )
      .then(({ data }) => {
        console.log(data.body)
        setAssistantList(data.body)
      })
  }

  return (
    <>
      <PageTitle
        mainTitle={'Onboarding Assistant'}
        v1Link={''}
        navNames={['Onboarding']}
      />
      <SpaceResponsive height={10} />
      <Wrapper>
        <div style={{ height: '30px', margin: '15px 0', display: 'flex' }}>
          <div style={{ width: '10px' }} />
          <Dropdown
            list={categoryList}
            onChange={e => setCategory(e.target.value)}
            value={category}
            type={'category'}
          />
          <div style={{ width: '10px' }} />
          <Dropdown
            list={genderList}
            onChange={e => setGender(e.target.value)}
            value={gender}
            type={'page'}
          />
        </div>
        <div style={{ display: 'flex', columnGap: '16px' }}>
          <Preview assistantList={assistantList} />
          <EditTable
            assistantList={assistantList}
            category={category}
            create={create}
            setCreate={setCreate}
            getOnboarding={getOnboarding}
            gender={gender}
          />
        </div>
      </Wrapper>
    </>
  )
}

export default Onboarding

const SpaceResponsive = styled.div`
  height: ${props => props.height}px;
  flex-shrink: 0;
`

const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  column-gap: 16px;
  padding: 0 15px;
  box-sizing: border-box;
`
